import { axiosInstance } from '@/http-common'
import axios from 'axios'

/**
 * Create a new user asset
 * @param data - User asset data
 */
export async function createUserAsset(data: any): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/api/v1/user-asset', data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Update an existing user asset
 * @param id - User ID
 * @param data - Updated user asset data
 */
export async function updateUserAsset(id: number | string, data: any): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.patch(`/api/v1/user-asset/${id}`, data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Delete a user asset (hard delete) and deactivate in auth service
 * @param id - User ID
 * @param email - User email
 */
export async function deleteUserAsset(id: number | string, email: string): Promise<any> {
  return new Promise(async (resolve, reject) => {
    try {
      // 1. Delete from backend (hard delete)
      const deleteResponse = await axiosInstance.delete(`/api/v1/user-asset/${id}`)

      if (deleteResponse.status === 200) {
        // 2. Deactivate in auth service
        try {
          const token = localStorage.getItem('jwt_token')
          await axios.patch(
            `${process.env.VUE_APP_AUTHORIZATION_SERVICE_URL}/users/deactivate`,
            { emails: [email] },
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
          )
          resolve(deleteResponse)
        } catch (authError) {
          console.error('Auth service deactivation failed:', authError)
          // Still resolve as main delete succeeded
          resolve(deleteResponse)
        }
      } else {
        reject(deleteResponse)
      }
    } catch (error) {
      reject(error)
    }
  })
}
